export class MessageConfig {
    id_: string;
    handler_: Function;
    context_: any;

    constructor(id: string, handler: Function, context: any) {
        this.id_ = id;
        this.handler_ = handler;
        this.context_ = context;
    }

    get id(): string {
        return this.id_;
    }

    get handler(): Function {
        return this.handler_;
    }
    
    get context(): Function {
        return this.context_;
    }
}
